/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.tw17

import io.kvision.redux.RAction
import pl.finn.forms.Zalacznik

enum class FormularzWidok {
  PUSTY,
  NOWY,
  EDYCJA
}

data class Formularz(
  val widok: FormularzWidok,
  val form: Tw17Form? = null,
  val token: String? = null,
  val zalaczniki: List<Zalacznik>? = null,
  val bladZapisu: String? = null
)

sealed class FormularzAction : RAction {
  data class Nowy(val formData: Tw17FormData) : FormularzAction()
  data class Edycja(val formData: Tw17FormData) : FormularzAction()
  data class DodajZalacznik(val zalacznik: Zalacznik, val aktualnyForm: Tw17Form) : FormularzAction()
  data class UsunZalacznik(val nazwa: String, val aktualnyForm: Tw17Form) : FormularzAction()
  data class BladZapisu(val bladZapisu: String, val aktualnyForm: Tw17Form) : FormularzAction()
}

fun formularzReducer(state: Formularz, action: FormularzAction): Formularz = when (action) {
  is FormularzAction.Nowy -> {
    Formularz(
      FormularzWidok.NOWY,
      action.formData.form,
      action.formData.token,
      bladZapisu = null
    )
  }
  is FormularzAction.Edycja -> {
    Formularz(
      FormularzWidok.EDYCJA,
      action.formData.form,
      action.formData.token,
      action.formData.zalaczniki,
      bladZapisu = null
    )
  }

  is FormularzAction.DodajZalacznik -> {
    val noweZalaczniki = state.zalaczniki?.plus(action.zalacznik) ?: listOf(action.zalacznik)
    state.copy(zalaczniki = noweZalaczniki, form = action.aktualnyForm)
  }
  is FormularzAction.UsunZalacznik -> {
    val noweZalaczniki = state.zalaczniki?.filter { it.nazwa != action.nazwa }
    state.copy(zalaczniki = noweZalaczniki, form = action.aktualnyForm)
  }
  is FormularzAction.BladZapisu -> {
    state.copy(bladZapisu = action.bladZapisu, form = action.aktualnyForm)
  }
}
